// src/utils/InfoFilterInputs.js

import React from 'react';
import { Box, TextField, Typography, InputAdornment, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function InfoFilterInputs({
  filterState,
  onFieldChange,
  showLabel = true,
  disabled = false, // NEW PROP
}) {
  // Styles duplicated here to ensure this module is self-contained for reuse
  const singleLineInputSx = {
    width: '100%',
    '& .MuiInputBase-root': {
      height: '30px',
      fontSize: '0.875rem',
      backgroundColor: '#fff',
    },
    '& .MuiInputBase-input': {
      padding: '0 8px',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiInputLabel-root': {
      top: '-5px',
    },
  };

  const infoFilterInputSx = {
    ...singleLineInputSx,
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#FF9900', // Default Orange
      },
      '&:hover fieldset': {
        borderColor: '#FF9900',
        borderWidth: '2px',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#FF9900',
        borderWidth: '2px',
      },
      // Ensure disabled state looks correct (lighter border)
      '&.Mui-disabled fieldset': {
        borderColor: '#e0e0e0',
      },
    },
  };

  const handleClearInfoA = () => {
    onFieldChange('infoFilterA', '');
  };

  const handleClearInfoB = () => {
    onFieldChange('infoFilterB', '');
  };

  return (
    <Box>
      {showLabel && (
        <Typography
          variant='caption'
          sx={{
            color: '#000000', // Black as requested
            fontWeight: 'bold',
            mb: 0.5,
            display: 'block',
          }}>
          Info Filter
        </Typography>
      )}

      {/* CONTAINER FOR BOTH FIELDS + AND */}
      <Box
        sx={{
          border: disabled ? '1px solid #e0e0e0' : '1px solid #FF9900',
          borderRadius: '4px',
          padding: 2,
          backgroundColor: disabled ? '#f5f5f5' : 'rgba(255, 153, 0, 0.02)',
          opacity: disabled ? 0.7 : 1,
        }}>
        {/* Field A */}
        <TextField
          fullWidth
          variant='outlined'
          size='small'
          disabled={disabled}
          sx={infoFilterInputSx}
          placeholder='Enter words (OR logic)...'
          value={filterState.infoFilterA || ''}
          onChange={(e) => onFieldChange('infoFilterA', e.target.value)}
          InputProps={{
            endAdornment:
              filterState.infoFilterA && !disabled ? (
                <InputAdornment position='end'>
                  <IconButton
                    onClick={handleClearInfoA}
                    size='small'
                    title='Clear'
                    disabled={disabled}
                    sx={{ padding: '2px' }}>
                    <CloseIcon sx={{ color: '#9e9e9e', fontSize: 20 }} />
                  </IconButton>
                </InputAdornment>
              ) : null,
          }}
        />

        <Typography
          variant='caption'
          sx={{
            display: 'block',
            textAlign: 'center',
            my: 1,
            fontWeight: 'bold',
            color: '#666',
          }}>
          AND
        </Typography>

        {/* Field B */}
        <TextField
          fullWidth
          variant='outlined'
          size='small'
          disabled={disabled}
          sx={infoFilterInputSx}
          placeholder='Enter words (OR logic)...'
          value={filterState.infoFilterB || ''}
          onChange={(e) => onFieldChange('infoFilterB', e.target.value)}
          InputProps={{
            endAdornment:
              filterState.infoFilterB && !disabled ? (
                <InputAdornment position='end'>
                  <IconButton
                    onClick={handleClearInfoB}
                    size='small'
                    title='Clear'
                    disabled={disabled}
                    sx={{ padding: '2px' }}>
                    <CloseIcon sx={{ color: '#9e9e9e', fontSize: 20 }} />
                  </IconButton>
                </InputAdornment>
              ) : null,
          }}
        />
      </Box>
    </Box>
  );
}
